import styled from 'styled-components';

export const Label = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.small};
  margin-bottom: 5px;
`;
